import { CallUI } from '@/components/CallUI'

export const DashboardPage = () => {
  return (
    <div className="h-full flex flex-col">
      <div className="border-b px-6 py-4">
        <h1 className="text-2xl font-bold">Dialer</h1>
        <p className="text-sm text-muted-foreground">
          Make outbound calls to prospects
        </p>
      </div>

      <div className="flex-1 p-6">
        <div className="max-w-2xl">
          <CallUI />
        </div>
      </div>
    </div>
  )
}
